<template>
  <section>
    <div class="columns">
      <div class="column is-narrow">
        <sc-field class="is-mobile-12">
          <sc-select
            v-model="filters.searchBy"
            @input="filters.searchParam = ''">
            <option
              v-for="item in searchByList"
              :key="item.value"
              :value="item.value">
              {{ item.name }}
            </option>
          </sc-select>
        </sc-field>
      </div>
      <div class="column is-narrow">
        <sc-field :type="fieldType">

          <sc-input
            :type="inputType"
            :placeholder="inputPlaceholder"
            :disabled="filters.searchBy === 'all'"
            v-if="filters.searchBy !== 'zipcode'"
            v-model="filters.searchParam"
            icon="search"
            :key="filters.searchBy"/>

          <sc-input
            type="search"
            placeholder="12345-678"
            v-if="filters.searchBy === 'zipcode'"
            v-model="filters.searchParam"
            v-mask="'cep'"
            icon="search"
            :key="filters.searchBy"/>

        </sc-field>
      </div>
      <div class="column is-narrow">
        <sc-field>
          <sc-button
            theme="primary"
            :loading="loading"
            :disabled="!isValid"
            @click="loadLogs"
            text="Buscar" />
        </sc-field>
      </div>

    </div>
  </section>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScIcon,
    ScField,
    ScInput,
    ScSelect,
  } from '@intelipost-js/secure-components';

  const { mapState, mapActions } = createNamespacedHelpers('analytic/logsApi');

  export default {
    name: 'sc-logs-api-filters',
    data() {
      return {
        fieldType: null,
        filters: {
          searchBy: 'all',
          searchParam: null,
        },
        searchByList: [
          {
            name: 'Todos',
            value: 'all',
          },
          {
            name: 'CEP',
            value: 'zipcode',
          },
          {
            name: 'Cotação',
            value: 'quote',
          },
          {
            name: 'Pedido',
            value: 'shipmentorder',
          },
          {
            name: 'Hashcode',
            value: 'hashcode',
          },
        ],
      };
    },
    computed: {
      ...mapState([
        'loading',
      ]),
      inputType() {
        const type = {
          all: 'search',
          quote: 'number',
          shipmentorder: 'search',
          hashcode: 'search',
        };

        return type[this.filters.searchBy];
      },
      inputPlaceholder() {
        const type = {
          all: '',
          quote: 'Nº da Cotação',
          shipmentorder: 'Nº do Pedido',
          hashcode: 'Hashcode',
        };

        return type[this.filters.searchBy];
      },
      isValid() {
        const { searchParam, searchBy } = this.filters;

        if (searchBy === 'all') {
          this.fieldType = null;
          return true;
        }

        const validations = {
          zipcode: () => searchParam && searchParam.length === 9,
          quote: () => searchParam && searchParam.length >= 1,
          shipmentorder: () => searchParam && searchParam.length >= 1,
          hashcode: () => searchParam && searchParam.length >= 1,
        };

        const isValid = validations[searchBy] ? validations[searchBy]() : false;

        this.fieldType = !isValid ? 'is-danger' : null;

        return isValid;
      },
    },
    methods: {
      ...mapActions([
        'getAllLogs',
        'getErrorLogs',
      ]),
      loadLogs() {
        this.getAllLogs(this.filters);
        this.getErrorLogs(this.filters);
      },
    },
    components: {
      ScButton,
      ScIcon,
      ScField,
      ScInput,
      ScSelect,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/api/components/sc-logs-api-filters/ScLogsApiFilters.vue